import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import type { AddonTypeName } from "app/contexts/AddonStateContext/const";
import type { INoTouchSuggestion } from "app/components/no-touch-purchase-modal/suggestions";
import {
    StyledLink,
    Suggestion,
    SuggestionIcon,
} from "app/components/no-touch-purchase-modal/summary-modal/suggestions/StyledNoTouchPurchaseSummaryModalSuggestions";
import { useNoTouchPurchaseSummaryModalSuggestions } from "app/components/no-touch-purchase-modal/summary-modal/suggestions/useNoTouchPurchaseSummaryModalSuggestions";
import { NO_TOUCH_PURCHASE_TRANSLATIONS } from "app/components/no-touch-purchase-modal/translations";

interface INoTouchPurchaseSummaryModalSuggestionsProps {
    addonType: AddonTypeName;
    suggestions: INoTouchSuggestion[];
}

export const NoTouchPurchaseSummaryModalSuggestions = ({
    addonType,
    suggestions,
}: INoTouchPurchaseSummaryModalSuggestionsProps) => {
    const { translate } = useTranslate();

    const { handleLinkClick, handleSuggestionClick } = useNoTouchPurchaseSummaryModalSuggestions({ addonType });

    return (
        <Flex
            flexDirection="column"
            gap="48px"
            justifyContent="space-between"
            height="100%"
        >
            {suggestions.length > 0 ? (
                <Flex
                    flexDirection="column"
                    gap="8px"
                >
                    <Text fontVariant="caption">{translate(NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions.caption)}</Text>

                    {suggestions.map((suggestion) => {
                        return (
                            <Suggestion
                                key={suggestion.titleKey}
                                onClick={() => handleSuggestionClick(suggestion.addon)}
                            >
                                <SuggestionIcon
                                    size="xs"
                                    color={colorsPalettes.carbon[200]}
                                />
                                <Flex
                                    flexDirection="column"
                                    gap="8px"
                                >
                                    <Flex gap="8px">
                                        <suggestion.icon
                                            size="xs"
                                            color={colorsPalettes.carbon[400]}
                                        />
                                        <Text fontVariant="body2">{translate(suggestion.titleKey)}</Text>
                                    </Flex>

                                    <Text
                                        fontVariant="body2"
                                        color={colorsPalettes.carbon[250]}
                                    >
                                        {translate(suggestion.descriptionKey)}
                                    </Text>
                                </Flex>
                            </Suggestion>
                        );
                    })}
                </Flex>
            ) : null}

            <Text fontVariant="body2">
                {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions.bottomText)}{" "}
                <StyledLink onClick={handleLinkClick}>
                    {translate(NO_TOUCH_PURCHASE_TRANSLATIONS.suggestions.bottomTextLink)}
                </StyledLink>
            </Text>
        </Flex>
    );
};
